define("shared/components/shared/portal", ["exports", "@ember/component", "@ember/template-factory", "@ember/debug", "@glimmer/component"], function (_exports, _component, _templateFactory, _debug, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@embroider/macros",0,"@glimmer/component"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.shouldRenderPortalContent}}
    {{#if @shouldAppend}}
      {{#in-element this.destinationElement insertBefore=null}}
        {{yield}}
      {{/in-element}}
    {{else}}
      {{#in-element this.destinationElement}}
        {{yield}}
      {{/in-element}}
    {{/if}}
  {{else}}
    {{yield}}
  {{/if}}
  */
  {
    "id": "JS2ySS8r",
    "block": "[[[41,[30,0,[\"shouldRenderPortalContent\"]],[[[41,[30,1],[[[40,[[[1,\"      \"],[18,2,null],[1,\"\\n\"]],[]],\"%cursor:0%\",[28,[37,2],[[30,0,[\"destinationElement\"]]],null],null]],[]],[[[40,[[[1,\"      \"],[18,2,null],[1,\"\\n\"]],[]],\"%cursor:1%\",[28,[37,2],[[30,0,[\"destinationElement\"]]],null]]],[]]]],[]],[[[1,\"  \"],[18,2,null],[1,\"\\n\"]],[]]]],[\"@shouldAppend\",\"&default\"],false,[\"if\",\"in-element\",\"-in-el-null\",\"yield\"]]",
    "moduleName": "shared/components/shared/portal.hbs",
    "isStrictMode": false
  });

  class PortalComponent extends _component2.default {
    get destinationElement() {
      (false && !(this.args.destinationElement) && (0, _debug.assert)('A `@destinationElement` argument must be provided', this.args.destinationElement));
      const destinationElement = document.getElementById(this.args.destinationElement);
      (false && !(destinationElement) && (0, _debug.assert)('Destination element must exist at the time of rendering', destinationElement));
      return destinationElement;
    }

    get shouldRenderPortalContent() {
      return !false || !!this.args.renderInTest;
    }

  }

  _exports.default = PortalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PortalComponent);
});